module.exports = {
      id: "cinema-usage",
      viewBox: "0 0 26.501 25.377",
      url: "/" + "sprite-4add775381efce29ef76f223dff77c00.svg#cinema",
      toString: function () {
        return this.url;
      }
    }